<div class="infinite-scroll" [hidden]="hideButton">
  <si-go-up-button [icon]="buttonIcon"
                   [styleClass]="buttonStyleClass"
                   [itemsLoaded]="itemsLoaded"
                   [bottom]="buttonBottom"
                   [scrollerId]="scrollerId"
                   (isBottomChange)="onChangeIsBottom()"
                   (scrollBarChange)="onChangeScrollBar($event)"
  ></si-go-up-button>
</div>
